import Cookies from 'universal-cookie'
import querystring from 'query-string'
import createConstant from '../../utils/createConst'
import { API_HOSTNAME } from '../../GlobalConfig'

const GET_INFOS = createConstant('info/GET_INFOS')
const GET_SUBINFOS = createConstant('info/GET_SUBINFOS')
const GET_INFOS_PROMOTED = createConstant('info/GET_INFOS_PROMOTED')
const GET_OTHER_INFOS = createConstant('info/GET_OTHER_INFOS')
const GET_CATEGORIES = createConstant('info/GET_CATEGORIES')
const GET_INFO_FILTER = createConstant('info/GET_INFO_FILTER')
const GET_INFO_DETAIL = createConstant('info/GET_INFO_DETAIL')
const GET_INFO_DIRECTORIES = createConstant('info/GET_INFO_DIRECTORIES')
const LIKE_INFO = createConstant('info/LIKE_INFO')

const cookies = new Cookies()

const initialState = {
  isRequesting: false,
  infos: undefined,
  subinfos: undefined,
  promoted: undefined,
  otherInfos: undefined,
  categories: undefined,
  filter: undefined,
  detail: undefined,
  directories: undefined,
  likedInfos: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_INFOS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_INFOS.success:
      return {
        ...state,
        isRequesting: true,
        infos: action.result.result,
      }
    case GET_INFOS.failed:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_SUBINFOS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_SUBINFOS.success:
      return {
        ...state,
        isRequesting: true,
        subinfos: action.result.result,
      }
    case GET_SUBINFOS.failed:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_INFOS_PROMOTED.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_INFOS_PROMOTED.success:
      return {
        ...state,
        isRequesting: true,
        promoted: action.result.result,
      }
    case GET_INFOS_PROMOTED.failed:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_OTHER_INFOS.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_OTHER_INFOS.success:
      return {
        ...state,
        isRequesting: true,
        otherInfos: action.result.result,
      }
    case GET_OTHER_INFOS.failed:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_CATEGORIES.request:
      return {
        ...state,
        isRequesting: true,
      }

    case GET_CATEGORIES.success:
      return {
        ...state,
        isRequesting: true,
        categories: action.result.result,
      }
    case GET_CATEGORIES.failed:
      return {
        ...state,
        isRequesting: true,
        error: action.error,
      }
    case GET_INFO_FILTER.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_INFO_FILTER.success:
      return {
        ...state,
        isRequesting: true,
        filter: action.result.result,
      }
    case GET_INFO_FILTER.failed:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_INFO_DETAIL.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_INFO_DETAIL.success:
      return {
        ...state,
        isRequesting: false,
        detail: action.result.result,
      }
    case GET_INFO_DETAIL.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    case GET_INFO_DIRECTORIES.request:
      return {
        ...state,
        isRequesting: true,
      }
    case GET_INFO_DIRECTORIES.success:
      return {
        ...state,
        isRequesting: false,
        directories: action.result.result,
      }
    case GET_INFO_DIRECTORIES.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    case LIKE_INFO.request:
      return {
        ...state,
        isRequesting: true,
      }
    case LIKE_INFO.success: {
      const { result, info } = action
      const likedInfos = state.likedInfos
      const newLikedInfos = !result.data ? likedInfos : [...likedInfos, info]

      return {
        ...state,
        isRequesting: false,
        likedInfos: newLikedInfos,
      }
    }
    case LIKE_INFO.failed:
      return {
        ...state,
        isRequesting: false,
        error: action.error,
      }
    default:
      return state
  }
}

const opts = {
  method: 'GET',
  mode: 'cors',
}

export const getInfos = (params) => {
  const qs = querystring.stringify(params)

  return {
    types: GET_INFOS,
    promise: fetch(`${API_HOSTNAME}/v1/infomina?${qs}`, opts),
  }
}

export const getSubinfos = (params) => {
  const qs = querystring.stringify(params)

  return {
    types: GET_SUBINFOS,
    promise: fetch(`${API_HOSTNAME}/v1/infomina?${qs}`, opts),
  }
}

export const getInfosPromoted = () => {
  const qs = querystring.stringify({ promoted: 1, limit: 4 })

  return {
    types: GET_INFOS_PROMOTED,
    promise: fetch(`${API_HOSTNAME}/v1/infomina?${qs}`, opts),
  }
}

export const getOtherInfos = (article) => {
  const qs = querystring.stringify({ limit: 4 })

  return {
    types: GET_OTHER_INFOS,
    promise: fetch(`${API_HOSTNAME}/v1/infomina/${article}/other?${qs}`, opts),
  }
}

export const getCategories = () => ({
  types: GET_CATEGORIES,
  promise: fetch(`${API_HOSTNAME}/v1/infomina/all_category`),
})

export const getInfoFilter = page => ({
  types: GET_INFO_FILTER,
  promise: fetch(`${API_HOSTNAME}/v1/category/${page}/info/filter`),
})

export const getInfoDetail = slug => ({
  types: GET_INFO_DETAIL,
  promise: fetch(`${API_HOSTNAME}/v1/infomina/${slug}`),
})

export const getInfoDirectories = () => ({
  types: GET_INFO_DIRECTORIES,
  promise: fetch(`${API_HOSTNAME}/v1/info-directory`),
})

export const likeInfo = (infoSlug) => {
  const token = cookies.get('TKN_MINAPOLI')
  const likeOptions = {
    ...opts,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: querystring.stringify({ type: 'like' }),
  }

  return {
    types: LIKE_INFO,
    info: infoSlug,
    promise: fetch(`${API_HOSTNAME}/v1/infomina/${infoSlug}/like`, likeOptions),
  }
}



// WEBPACK FOOTER //
// ./src/modules/Info/index.js